/// <reference path="../app.ts" />
namespace Cfnc {
    "use strict";

    interface IShell {
        log: (msg, data?, showToast?) => void;
        logError: (msg, data?, showToast?) => void;
        logSuccess: (msg, data?, showToast?) => void;
        busyMessage: string;
        isBusy: boolean;
        spinnerOptions: SpinnerOptions;
        activate: () => void;
        toggleSpinner: (on: boolean) => void;
        isLoggedIn: boolean;
        user: any;
        currentYear: number;
    }

    class Shell implements IShell {
        static controllerId: string = "shell";
        static $inject: Array<string> = ["$rootScope", "common", "config", "authentication", "Restangular", "routemediator", "$http", "$cookies"];
        cfncUrl: string;
        javaUrl: string;
        umbracoUrl:string;
        transitionsUrl: string;
        log: (msg, data?, showToast?) => void;
        logError: (msg, data?, showToast?) => void;
        logSuccess: (msg, data?, showToast?) => void;
        busyMessage: string;
        isBusy: boolean;
        spinnerOptions: SpinnerOptions;
        isLoggedIn: boolean;
        user: any;
        breadCrumbs: IRoute[];
        currentYear: number;
        siteNotification: any = { show: false };
;

        constructor(private $rootScope: ng.IRootScopeService, private common: ICommonFactory, private config: IConfig, private authentication: Security.IAuthenticationService,
            private Restangular: Restangular.IService, private routemediator: IRouteMediator, private $http: angular.IHttpService, private $cookies: angular.cookies.ICookiesService) {
            this.log = common.logger.getLogFn(Shell.controllerId);
            this.logError = common.logger.getLogFn(Shell.controllerId, "error");
            this.logSuccess = common.logger.getLogFn(Shell.controllerId, "success");
            this.busyMessage = "Please Wait....";
            this.isBusy = true;
            this.currentYear = new Date().getFullYear();
            this.umbracoUrl = this.config.umbracoUrl;

            this.spinnerOptions = {
                radius: 40,
                lines: 7,
                length: 0,
                width: 30,
                speed: 1.7,
                corners: 1.0,
                trail: 100,
                color: "#F58A00"
            };

            $rootScope.$on("$routeChangeStart",
                (event, next, current): void => {
                    this.toggleSpinner(true);
                }
            );

            $rootScope.$on(config.events.controllerActivateSuccess,
                (data): void => { this.toggleSpinner(false); }
            );

            $rootScope.$on(config.events.spinnerToggle,
                (data: any): void => { this.toggleSpinner(data.show); }
            );

            $rootScope.$on(config.events.login, (data: any, user: any): void => {
                this.user = user;
                this.isLoggedIn = true;
            });

            $rootScope.$on(config.events.logout, (data: any): void => {
                this.user = null;
                this.isLoggedIn = false;
            });

            $rootScope.$on("$routeChangeSuccess",
                (event, next, current): void => {
                    this.breadCrumbs = null;
                    if (this.routemediator.breadCrumbs != null && _.last(this.routemediator.breadCrumbs).config.settings.showBreadcrumbs != false) {
                        this.breadCrumbs = this.routemediator.breadCrumbs;
                    }
                });

            this.breadCrumbs = null;
            if (this.routemediator.breadCrumbs != null && _.last(this.routemediator.breadCrumbs).config.settings.showBreadcrumbs != false) {
                this.breadCrumbs = this.routemediator.breadCrumbs;
            }

            this.activate();
        }

        activate(): void {
            this.common.activateController([this.getSiteNotification()], Shell.controllerId);
            this.cfncUrl = this.config.cfncUrl;
            this.javaUrl = this.config.javaUrl;
            this.transitionsUrl = this.config.transitionsUrl;
        }

        logOut(): void {
            this.authentication.logout();
        }

        toggleSpinner(on: boolean): void {
            this.isBusy = on;
        }

        getSiteNotification(): angular.IPromise<any> {
            return this.Restangular.withConfig(config => {
                config.setBaseUrl(this.umbracoUrl);
            }).one("api/sitenotifications").get({ absoluteUrls: true})
                .then(result => {
                    if (result && result.message) {
                        this.siteNotification = result;

                        var showNotice = this.$cookies.get("showNotice");
                        var noticeDate = decodeURIComponent(this.$cookies.get("noticeDate"));

                        this.siteNotification.show = (showNotice == null || showNotice != "false" || noticeDate == null || moment.utc(this.siteNotification.updatedDate).format("M/D/YYYY h:mm:ss A") != noticeDate);
                    }

            });
        }

        hidenotification() {
            var noticeDate = moment.utc(this.siteNotification.updatedDate).format("M/DD/YYYY h:mm:ss A");
            this.$cookies.put("showNotice", "false", { path: "/", domain: ".cfnc.org" });
            this.$cookies.put("noticeDate", noticeDate, { path: "/", domain: ".cfnc.org" });
        }
    }


    angular.module("app").controller(Shell.controllerId, Shell);
}